import { minimalThemeTemplate } from "@/player/themes/minimal";
import { sutroThemeTemplate } from "@/player/themes/sutro";
import { vimeonovaThemeTemplate } from "@/player/themes/vimeonova";

export const PLAYER_THEMES = {
    VIMEONOVA: {
        id: 'media-theme-vimeonova',
        template: vimeonovaThemeTemplate,
        title: 'vimeonova',
    },
    MINIMAL: {
        id: 'media-theme-minimal',
        template: minimalThemeTemplate,
        title: 'minimal',
    },
    SUTRO: {
        id: 'media-theme-sutro',
        template: sutroThemeTemplate,
        title: 'sutro',
    },
};